var Mustache = require("mustache")

export default class IcmaDoc {
    constructor() {
        //eslint-disable-next-line
        this.json = `{"pageSize":"LETTER","pageMargins":[72,45,72,45],"content":[{"alignment":"left","bold":true,"color":"red","text":"{{{instructions}}}","margin":[0,-15,0,0]},{"image":"{{{logo}}}","width":120,"alignment":"center","margin":[0,0,0,14]},{"text":"Independent Contractor Master Agreement","alignment":"center","bold":true,"fontSize":12,"margin":[0,0,0,14]},{"text":"Between","alignment":"center","bold":true,"fontSize":10,"margin":[0,0,0,14]},{"columns":[{"text":["Elite Logistics, Inc\\n","Attn: Brent LaFave\\n","730 S Jason St, Unit 28\\n","Denver, CO  80223\\n","Telephone: 303.994.9633"]},{"text":["Contractor:  {{{userName}}}\\n\\n","DBA:  {{{companyName}}}\\n\\n","Telephone:  {{{phone}}}"],"alignment":"right"}],"margin":[0,0,0,16]},{"text":[{"text":"THIS AGREEMENT (","bold":true},{"text":"¨Agreement¨","bold":true},") is between Elite Logistics, Inc. (",{"text":"¨Elite¨","bold":true},") and the above named party (",{"text":"¨Contractor¨","bold":true},") [Individually a “Party” and collectively the “Parties”] effective this {{{invite_dayOrdinal}}} day of {{{invite_month}}}, {{{invite_year}}} (the ",{"text":"¨Effective Date¨","bold":true},")."],"style":"para"},{"text":[{"text":"WHEREAS","bold":true},", Elite provides logistic support to businesses (",{"text":"“Client[s]”","bold":true},{"text":") through independent contractors who use their own rolling equipment, supplies, materials, tools and who provide their own fuel, maintenance, and insurance related to the aforesaid; and\\n\\n"},{"text":"WHEREAS","bold":true},", Contractor is a business separate and apart from Elite with no overlapping ownership or control; and is customarily engaged in a business related to the service to be performed under this Agreement; and,\\n\\n",{"text":"WHEREAS","bold":true},", Contractor provides workers compensation insurance and unemployment insurance for its employees.\\n\\n",{"text":"NOW THEREFORE","bold":true},", in consideration of the covenants and restrictions herein, the Parties agree:\\n"],"style":"para"},{"text":"Section I:  Assignments\\n","style":"section"},{"text":"Elite may present opportunities to Contractor to provide delivery services for Clients (an ¨Assignment¨) setting forth the Client's requirements and needs including the dates and times needed and delivery destination(s) where known.  Contractor shall have the option to accept or reject the Assignment with Clients; however, all Assignments shall be subject to approval of Contractor by the Client.  An assignment will be delivery, or other service, that takes one day or less to complete unless stated otherwise.  An Assignment will not include special deliveries or similar services (generally services that will take four hours or less to complete).","style":"para"},{"text":"Section II:  Subcontract\\n","style":"section"},{"text":"Contractor may fulfill any Assignment by use of its employees or may subcontract an Assignment to a third party.","style":"para"},{"text":"Section III:  Term\\n","style":"section"},{"text":"The term of this Agreement shall commence on the Effective Date and shall be applicable to all Assignments.  Notwithstanding the aforesaid, Elite does not guaranty Contractor any Assignment or reassignment of Contractor to a Client after any Assignment.","style":"para"},{"text":"Section IV:  Disclaimers\\n","style":"section"},{"text":"CONTRACTOR IS NOT ENTITLED TO UNEMPLOYMENT COMPENSATION INSURANCE BENEFITS UNLESS UNEMPLOYMENT COMPENSATION INSURANCE COVERAGE IS PROVIDED BY CONTRACTOR OR SOME OTHER ENTITY;","style":["para","dark"]},{"text":"CONTRACTOR IS OBLIGATED TO PAY FEDERAL AND STATE INCOME TAX ON ANY MONEYS PAID PURSUANT TO THE CONTRACT RELATIONSHIP;","style":["para","dark"]},{"text":"CONTRACTOR IS NOT REQUIRED TO ACCEPT AN ASSIGNMENT;","style":["para","dark"]},{"text":"CONTRACTOR IS NOT REQUIRED TO WORK EXCLUSIVELY FOR ELITE, EXCEPT THAT CONTRACTOR MAY CHOOSE TO WORK EXCLUSIVELY FOR A FINITE PERIOD OF TIME SPECIFIED IN THIS AGREEMENT OR IN AN ASSIGNMENT;","style":["para","dark"]},{"text":"ELITE DOES NOT ESTABLISH A QUALITY STANDARD FOR CONTRACTOR; EXCEPT THAT ELITE MAY PROVIDE PLANS AND SPECIFICATIONS FOR AN ASSIGNMENT BUT ELITE CANNOT OVERSEE THE ACTUAL ASSIGNMENT OR INSTRUCT CONTRACTOR AS TO HOW THE ASSIGNMENT WILL BE PERFORMED;","style":["para","dark"]},{"text":"ELITE DOES NOT PAY A SALARY OR HOURLY RATE BUT RATHER A FIXED OR CONTRACT RATE FOR AN ASSIGNMENT;","style":["para","dark"]},{"text":"ELITE CANNOT TERMINATE AN ASSIGNMENT DURING THE ASSIGNMENT UNLESS CONTRACTOR VIOLATES THE TERMS OF THE ASSIGNMENT OR THIS AGREEMENT OR FAILS TO PRODUCE A RESULT THAT MEETS THE SPECIFICATIONS OF THE ASSIGNMENT;","style":["para","dark"]},{"text":"ELITE DOES NOT PROVIDE ANYTHING MORE THAN MINIMAL TRAINING FOR CONTRACTOR;","style":["para","dark"]},{"text":"ELITE DOES NOT PROVIDE TOOLS OR BENEFITS TO CONTRACTOR; EXCEPT THAT MATERIALS AND EQUIPMENT MAY BE SUPPLIED;","style":["para","dark"]},{"text":"ELITE DOES NOT DICTATE THE TIME OF PERFORMANCE OF AN ASSIGNMENT; EXCEPT THAT A COMPLETION SCHEDULE AND A RANGE OF MUTUALLY AGREEABLE WORK HOURS MAY BE ESTABLISHED;","style":["para","dark"]},{"text":"IF CONTRACTOR IS AN INDIVIDUAL, ELITE DOES NOT PAY CONTRACTOR PERSONALLY BUT RATHER MAKES CHECKS PAYABLE TO THE TRADE OR BUSINESS NAME OF CONTRACTOR.","style":["para","dark"]},{"text":"ELITE DOES NOT COMBINE ITS BUSINESS OPERATIONS IN ANY WAY WITH CONTRACTOR'S BUSINESS, BUT INSTEAD MAINTAINS SUCH OPERATIONS AS SEPARATE AND DISTINCT.","style":["para","dark"]},{"text":"Section V:  Subcontractors and Employees of Contractor\\n","style":"section"},{"text":"Contractor may use sub-contractors or employees. Contractor shall be solely responsible for the supervision of its employees and contractors and the payment of compensation, wages, workers compensation insurance, unemployment insurance, taxes, and similar matters related to Contractor’s owners, employees, and contractors. Contractor shall save and hold Elite harmless from any claims or demands arising related to the relationship between Contractor and its employees and contractors including, but not limited to: i) claims by Contractor’s owners, employees, or contractors for damages, injuries, losses, payments, salaries, taxes, benefits, or other matters; and, ii) claims by any third parties, including, but not limited to, Clients, unrelated parties, and governmental agencies, for damages, injuries, or losses of any kind related to an Assignment.\\n\\n","style":"para"},{"text":"Section VI:  Relationship Between Parties\\n","style":"section"},{"text":[{"text":"A.    ","style":"bullet"},{"text":"Independent Contractor.  ","bold":true,"italics":true},"Contractor is engaged in an independent business and customarily has performed or does perform services for businesses other than Elite.  Contractor will perform Assignments as an independent contractor and not as an agent, partner, venturer, or employee of Elite."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Training.  ","bold":true,"italics":true},"Elite shall not provide Contractor with any training or continuing education. The cost of any training or continuing education required to perform the Assignment shall be provided and paid by Contractor."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Authority.  ","bold":true,"italics":true},"Contractor does not have the authority to act for or bind Elite in any respect or to incur any debts or liabilities in the name, or on behalf, of Elite."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Coordination.  ","bold":true,"italics":true},"Elite shall not control, oversee, or supervise Contractor in any way in the fulfillment of an Assignment, or control the manner in which Contractor fulfills the Assignment. However, Elite shall be available for consultation, coordination, assistance, coverage issues, and/or advice."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"No Guaranty of Assignments.  ","bold":true,"italics":true},"Elite does not guarantee Assignments to Contractor. Contractor waives any claim against Elite for dependency upon Assignments and shall release, indemnify, and hold Elite harmless from any claims and liabilities relating to Contractor’s financial stability, which may result in a lack of Assignments."],"style":"para"},{"text":[{"text":"F.    ","style":"bullet"},{"text":"Workers Compensation Insurance.  ","bold":true,"italics":true},"Contractor shall provide Elite with proof, or a waiver, of workers compensation insurance for all owners, employees, or contractors of Contractor in accordance with all applicable laws, prior to commencing any Assignment and thereafter upon request of Elite. All such insurance shall be paid by Contractor. If Contractor does not maintain workers’ compensation insurance as required by law, Elite may recover from Contractor all costs that it sustains in providing workers’ compensation insurance for Contractor’s employees and contractors."],"style":"para"},{"text":[{"text":"G.    ","style":"bullet"},{"text":"Business Cards.  ","bold":true,"italics":true},"Contractor may use business cards setting forth Contractor’s name and contact information. Contractor shall not reflect any business relationship with Elite on any business cards, invoices, statements, or, advertisements except for stating that Elite is one of its customers.\\n\\n"],"style":"para"},{"text":"Section VII:  Conduct and Performance\\n","style":"section","xpageBreak":"before"},{"text":[{"text":"A.    ","style":"bullet"},{"text":"Quality.  ","bold":true,"italics":true},"Contractor shall use its best efforts to complete all Assignments in accordance with the specifications of Assignment."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Identification.  ","bold":true,"italics":true},"While fulfilling an Assignment, Contractor shall furnish and maintain, at its own cost and expense, identification as required by Client (e.g. an identification badge)."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Workplace.  ","bold":true,"italics":true},"Contractor shall provide services to and from Clients’ sites and facilities or such other locations as set forth in an Assignment. Any preparatory work required of Contractor to perform an Assignment shall be performed at the workplace of Contractor, and not of Elite, at Contractor’s sole cost and expense."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Equipment.  ","bold":true,"italics":true},"Contractor shall provide services to and from Clients’ sites and facilities or such other locations as set forth in an Assignment. Any preparatory work required of Contractor to perform an Assignment shall be performed at the workplace of Contractor, and not of Elite, at Contractor’s sole cost and expense."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"Vehicle.  ","bold":true,"italics":true},"Contractor shall provide a vehicle sufficient to perform an Assignment and in relation to such vehicle, Contractor shall:"],"style":"para"},{"text":[{"text":"i)  ","style":"bullet"},{"text":"Vehicle Size","bold":true,"decoration":"underline"},".  Not use a vehicle for an Assignment with a Gross Vehicle weight in excess of 10,000 pounds."],"margin":[20,0,0,6]},{"text":[{"text":"ii)  ","style":"bullet"},{"text":"Expenses","bold":true,"decoration":"underline"},".  Pay for all costs and expenses associated with such vehicle, including, but not limited to: a) the purchase of the vehicle in Contractor’s business name; b) registration fees; c) license fees; d) inspection fees; d) fines; f) maintenance and repairs; g) personal property taxes; g) sales and use taxes; and h) fuel, oil, fluids, tires, and other replacement parts."],"margin":[20,0,0,6]},{"text":[{"text":"iii)  ","style":"bullet"},{"text":"Insurance","bold":true,"decoration":"underline"},".  Contractor shall provide Elite proof of, and shall maintain at Contractor’s sole cost and expense, insurance in accordance with the following:"],"margin":[20,0,0,6]},{"text":[{"text":"a)  ","style":"bullet"},"Vehicle Insurance: For each vehicle used by Contractor pursuant to an Assignment, Contractor shall maintain insurance coverage with $100,000/$300,000/$500,000 of coverage."],"margin":[40,0,0,6]},{"text":[{"text":"b)  ","style":"bullet"},"Liability Insurance: Contractor shall maintain general liability insurance with a single combined liability limit of not less than one million dollars ($1,000,000.00) insuring against all liability of Contractor and its authorized representatives in connection with an Assignment"],"margin":[40,0,0,6]},{"text":[{"text":"c)  ","style":"bullet"},"Additional Insureds: The above insurance policies shall name Elite as an additional insured and shall provide that the policies may not be changed, non-renewed, terminated, or canceled unless the insurance carrier provides at least thirty (30) days prior written notice of the aforesaid to Elite."],"margin":[40,0,0,6]},{"text":[{"text":"F.    ","style":"bullet"},{"text":"Laws.  ","bold":true,"italics":true},"Contractor shall comply with all federal, state, municipal, county, or other governmental or quasigovernmental requirements, laws, ordinances, regulations, and rules in the performance of an Assignment."],"style":"para"},{"text":[{"text":"G.    ","style":"bullet"},{"text":"Representations.  ","bold":true,"italics":true},"Contractor shall commit no deceptive, misleading, or unethical acts in fulfilling an Assignment and shall make no representations, warranties, or guarantees on behalf of Elite."],"style":"para"},{"text":"Section VIII:  Payment\\n","style":"section"},{"text":[{"text":"A.    ","style":"bullet"},{"text":"Profits/Losses.  ","bold":true,"italics":true},"Contractor shall be entitled to all profits it earns and losses it incurs related to an Assignment."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Invoices.  ","bold":true,"italics":true},"Contractor shall periodically invoice Elite for Assignments and, at the request of Elite, shall provide backup documentation for the matters claimed in invoices."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Payments.  ","bold":true,"italics":true},"Contractor shall be paid for an Assignment pursuant to the Schedule set forth in Exhibit A as may be modified from time-to-time regardless of the number of hours expended by Contractor. Payment shall be made within 15 business days of receipt by Elite of a complying invoice and Contractor providing any backup documentation requested by Elite."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Trade or Business Name.  ","bold":true,"italics":true},"All payments shall be payable to Contractor’s trade or business name."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"Taxes.  ","bold":true,"italics":true},"Contractor shall withhold, contribute, and pay all applicable FICA, federal, state, and local income taxes or assessments for or on behalf of its employees. Elite shall provide Contractor a 1099 tax form after each calendar year in accordance with applicable laws."],"style":"para"},{"text":"Section IX:  Indemnification\\n","style":"section","xpageBreak":"before"},"Contractor shall save and hold Elite, its owners, affiliates, agents, directors, officers, contractors, and employees harmless from any claims, liabilities, costs, or damages incurred as a result of:\\n\\n",{"text":[{"text":"A.    ","style":"bullet"},{"text":"Taxes.  ","bold":true,"italics":true},"Taxes due for any payment made by Elite to Contractor."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Employees and Contractors.  ","bold":true,"italics":true},"Payments due for services, including taxes due thereon, made to Contractor’s owners, employees, and contractors."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Debts.  ","bold":true,"italics":true},"Any debts, taxes, or liabilities of Contractor."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Acts.  ","bold":true,"italics":true},"Tortuous or contractual acts of Contractor whether or not related to the Assignment."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"Consequential Liability.  ","bold":true,"italics":true},"Liabilities and damages caused to third parties by Contractor."],"style":"para"},{"text":[{"text":"F.    ","style":"bullet"},{"text":"Workers Compensation.  ","bold":true,"italics":true},"Worker’s compensation insurance premiums paid by Elite for Contractors employees or contractors."],"style":"para"},{"text":"In the event of any claim set forth above against Elite, Contractor shall reimburse Elite for all costs of defense (including but not limited to attorney’s fees, costs, and expenses whether or not suit is actually filed) within 30 days of Elite forwarding an invoice to Contractor for such fees, costs, expenses or damages.","margin":[0,0,0,10]},{"text":"Section X:  Termination\\n","style":"section"},{"text":[{"text":"A.    ","style":"bullet"},{"text":"Without Cause.  ","bold":true,"italics":true},"Either Party may terminate this Agreement at any time without notice and without cause in which case Contractor shall not thereafter by offered Assignments. Notwithstanding the aforesaid, this Agreement shall not be terminated during an Assignment unless Contractor violates the terms of an Assignment or fails to meet the specifications of an Assignment."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Payment Upon Termination.  ","bold":true,"italics":true},"Each Party will pay all amounts due to the other Party upon the termination of this Agreement and shall pay any future amounts due to the other Party as they become due. Elite may apply any setoffs it may have against Contractor towards any payment due to Contractor."],"style":"para"},{"text":"Section XI:  Confidential Information\\n","style":"section"},{"text":[{"text":"A.    ","style":"bullet"},{"text":"Confidential Information.  ","bold":true,"italics":true},"“Confidential Information” shall mean any business information, including Client information obtained in connection with this Agreement, in a tangible form which is marked as confidential or proprietary, otherwise learned, or which is known, or should be known, to be confidential."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"No Confidential Information to Elite.  ","bold":true,"italics":true},"Elite does not wish to receive Confidential Information from Contractor."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Terms of Non-Disclosure.  ","bold":true,"italics":true},"Contractor shall not disclose, use, or copy Confidential Information of Elite during the term of this Agreement (except in furtherance of an Assignment) and for a period of two (2) years thereafter other than in the fulfillment of an Assignment unless specifically authorized to do so in writing by Elite which authorization may be withheld by Elite for any reason or no reason. Contractor shall exercise of at least the same degree of care used to protect its own information of like importance but not less than a reasonable degree of care."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Client.  ","bold":true,"italics":true},"Contractor shall be subject to the Indiana Uniform Trade Secrets Act in all of its dealings with Clients."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"On Site Information.  ","bold":true,"italics":true},"The nature of an Assignment may require Contractor to be present at the site of Elite or a Client where Contractor may hear or learn of Confidential Information and Contractor may be required to access information on computers of Elite all of which shall be deemed Confidential Information subject to the restrictions set forth herein."],"style":"para"},{"text":"Section XII:  Non-Solicitation of Elite Employees and Contractors\\n","style":"section"},"Contractor shall not, on its own behalf or on behalf of any third party recruit, solicit, or hire employees or other independent contractors of Elite employed or under contract with Elite during the period of this Agreement or for a period of two (2) years after termination of this Agreement. In the event of a violation of the terms herein, damages will be difficult to ascertain but will nevertheless be real and substantial and as a result thereof, Elite shall be entitled to liquidated damages equal to the average monthly salary or contract payments times six (6) made by Elite to the employee or independent contractor later hired by, or contracting with, Contractor or a third party as a result of the acts of Contractor. Said liquidated damages are fair and reasonable under these circumstances. In addition, such solicitation or hiring will cause immediate and irreparable injury to Elite and as a result thereof, Elite shall be entitled to injunctive relief without bond. For purposes of this Section, the term “Solicit” means any direct or indirect communication of any kind whatsoever, regardless of by whom initiated, inviting, advising, encouraging, or requesting any person or entity, in any manner, to take or refrain from taking any action with Elite as related to their employment by, or contract with, Elite.\\n\\n",{"text":"Section XIII:  Non-Circumvention and Non-Solicitation of Clients\\n","style":"section"},{"text":[{"text":"A.    ","style":"bullet"},{"text":"Prohibitions.  ","bold":true,"italics":true},"Due to the amount and sensitivity of Confidential Information that will be provided to Contractor, or to which it may have access including, but not limited to, marketing plans, Client billing history, or Elite business operations, and other financial data of Elite. Contractor shall not, on its own behalf or on behalf of any third party, solicit business from any Client using Confidential Information during the term of the Agreement and for a period of one (1) year thereafter."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Solicit.  ","bold":true,"italics":true},"For purposes of this Section, the term “Solicit” means any direct or indirect communication of any kind whatsoever, regardless of by whom initiated, inviting, advising, encouraging, or requesting any person or entity, in any manner, to take or refrain from taking any action which is materially based on or considers Confidential Information."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Damages.  ","bold":true,"italics":true},"In the event of a violation of the Prohibitions stated above, damages will be difficult to determine, but will, nevertheless, be real and substantial and therefore the Parties agree to liquidated damages in an amount equal to the greater of: i) 150% of the average monthly billing by Elite of that Client times 12 during the preceding 12 month period (measured from the date of discovery of the initial violation) or ii) 66 2/3% of the gross amount of the first year’s fees billed to that Client by Contractor on its own behalf or a third party with whom Contractor is or has been associated in the aforesaid solicitation. Such liquidated damages are fair and reasonable under these circumstances."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Injunctive Relief.  ","bold":true,"italics":true},"Notwithstanding the right of Elite to liquidated damages and actual damages, a violation of the prohibitions herein will cause Elite immediate and irreparable injury and as a result thereof, Elite shall be entitled to injunctive relief without bond."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"Notice.  ","bold":true,"italics":true},"Elite shall be entitled to provide notice of this Agreement to any Clients at any time without any liability to Contractor for such disclosure."],"style":"para"},{"text":"Section XIV:  Non-Disparagement\\n","style":"section"},"Contractor shall not disparage Elite, or any of its affiliated companies, employees, officers, agents or contractors or otherwise act in a fashion designed to injure the business of Elite. This provision will not apply to truthful comments in response to a lawful subpoena or other legal process. In the event of a violation of this Section, the Parties agree that damages will difficult to determine, but are nevertheless real and substantial and therefore agree to liquidated damages in the amount equal to $5,000 for each incident of disparagement. Continuous statements made on separate dates, or if on the same date to separate people, shall be considered separate incidents each resulting in liquidated damages in the aforesaid amount. Such liquidated damages are fair and reasonable.\\n\\n",{"text":"Section XV:  Disputes, Jurisdiction, Mediation\\n","style":"section"},"In the event of a dispute regarding this Agreement or the relationship or business dealings between the Parties, the following shall apply:\\n\\n",{"text":[{"text":"A.    ","style":"bullet"},{"text":"Negotiations/Mediation.  ","bold":true,"italics":true},"The Parties shall first attempt in good faith to resolve any dispute through private negotiations. If the dispute is not resolved within 30-days of the first written notice of the dispute, the dispute shall be submitted for mediation in the County of Marion, Indiana, to a mutually agreeable mediator."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Mandatory Arbitration.  ","bold":true,"italics":true},"Any dispute not resolved by mediation as set forth above will be submitted for mandatory arbitration in the County of Marion, Indiana, to a mutually agreeable arbitrator. All costs of arbitration shall be shared equally between the Parties."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Award.  ","bold":true,"italics":true},"The Final Award issued by the arbitrator shall not include comprehensive findings of fact and conclusions of law. Judgment upon the Final Award may be entered in any Indiana Court that has jurisdiction."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Jury Trial.  ","bold":true,"italics":true},"THE PARTIES WAIVE ANY RIGHT TO A TRIAL BY JURY OR BY A JUDGE."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"Attorneys’ Fees.  ","bold":true,"italics":true},"In the event of any arbitration or litigation between the Parties related to this Agreement, the prevailing Party shall be entitled to recover its reasonable attorneys’ fees."],"style":"para"},{"text":[{"text":"F.    ","style":"bullet"},{"text":"Damage Limitations.  ","bold":true,"italics":true},"Elite will not be liable to Contractor for any incidental, indirect, special, or consequential damages of any kind including, but not limited to, any loss of business, loss of income, or loss of profit, even if advised of the possibility of such damage or if such damage could have been reasonably foreseen. In the event of any claim by Contractor against Elite, Contractor’s remedies shall be solely limited to the assets of Elite. No officer, director, employee, or agent of Elite shall have any personal liability to Contractor for any claim of Contractor arising out of this Agreement or the relationship between Elite and Contractor. If any such claim exists in law or equity against an officer, director, or other employee or independent contractor of Elite, Contractor waives such claim."],"style":"para"},{"text":"Section XVI:  Miscellaneous\\n","style":"section"},{"text":[{"text":"A.    ","style":"bullet"},{"text":"Execution.  ","bold":true,"italics":true},"This Agreement may be executed in one or more counterparts, each of which shall constitute one and the same instrument. Execution may be by electronic signature wherein delivery shall be deemed completed by e-mail if there is electronic confirmation of receipt and opening of the e-mail by the recipient or by facsimile transmission with confirmation of delivery to the recipient."],"style":"para"},{"text":[{"text":"B.    ","style":"bullet"},{"text":"Complete Agreement.  ","bold":true,"italics":true},"This Agreement contains a complete Agreement concerning the contractual relationship between Contractor and  Elite and shall supersede all agreements between the Parties. Contractor acknowledges that Elite has made no further representation regarding the terms of this relationship."],"style":"para"},{"text":[{"text":"C.    ","style":"bullet"},{"text":"Assignment.  ","bold":true,"italics":true},"Contractor shall not have the right to assign this Agreement."],"style":"para"},{"text":[{"text":"D.    ","style":"bullet"},{"text":"Savings Clause and Severability.  ","bold":true,"italics":true},"If in any action before any Court or tribunal empowered to enforce the terms and conditions herein, any portion or section of this Agreement is found to be unenforceable, illegal, or unlawful for any reason, then such term, restriction, remedy, portion, section, or covenant shall be deemed modified to the extent necessary to make it enforceable. In the event that any of the terms and conditions herein are declared invalid, unenforceable, or void for any reason whatsoever, the remaining terms and conditions shall be in full force and effect and binding upon the Parties herein as if the invalid, unenforceable, or void terms were not made a part hereof."],"style":"para"},{"text":[{"text":"E.    ","style":"bullet"},{"text":"Waiver.  ","bold":true,"italics":true},"The failure of either Party to exercise any right shall not be construed to be a waiver unless agreed upon in writing. A waiver in any one instance will not constitute an amendment to this Agreement or indicate any continued waivers of such right on any other occasion."],"style":"para"},{"text":[{"text":"F.    ","style":"bullet"},{"text":"Survival.  ","bold":true,"italics":true},"The provisions of this Agreement that by their nature continue after termination will survive the expiration, termination, or cancellation of this Agreement including, but not limited to, §§IX-XV."],"style":"para"},{"text":[{"text":"G.    ","style":"bullet"},{"text":"Modifications.  ","bold":true,"italics":true},"No waiver or modification of this Agreement or any covenants herein shall be valid unless made in writing and duly executed by both Parties. No evidence of any waiver or modification shall be offered or received into evidence or any proceeding for arbitration or litigation between the Parties unless such waiver or modification is in writing, duly executed by both Parties."],"style":"para"},{"text":[{"text":"H.    ","style":"bullet"},{"text":"Attorneys' Fees.  ","bold":true,"italics":true},"In the event any Party violates any of the terms herein, the defaulting Party shall be liable for the reasonable attorney's fees of the non-defaulting Party incurred as a result of enforcing the terms herein whether or not litigation, mediation, or arbitration is commenced."],"style":"para"},{"text":[{"text":"I.    ","style":"bullet"},{"text":"Law.  ","bold":true,"italics":true},"This Agreement shall be governed and controlled by the laws of Indiana and the sole jurisdiction and the venue for hearing any matters arising out of, or related to, this Agreement shall be in the County of Marion, Indiana."],"style":"para"},{"text":[{"text":"J.    ","style":"bullet"},{"text":"Assignability.  ","bold":true,"italics":true},"This Agreement shall inure to the benefit of, and shall be binding on, Elite and any entity with which Elite may merge or assign its rights and duties under this Agreement."],"style":"para"},{"text":[{"text":"K.    ","style":"bullet"},{"text":"Notices.  ","bold":true,"italics":true},"Any notice required herein shall be effective three days after mailing Certified Mail, in the U.S. Mail, postage prepaid or upon actual receipt if hand-delivered or forwarded by overnight carrier. A notice transmitted and delivered by fax or e-mail or other electronic means shall be effective if there is proof of delivery in which case the effective date shall be the date of delivery. Notice shall be made to the addresses set forth above."],"style":"para"},{"text":[{"text":"L.    ","style":"bullet"},{"text":"Time is of the Essence.  ","bold":true,"italics":true},"Time is of the essence in the performance of any duty or requirement in this Agreement and a significant and material term of this Agreement."],"style":"para"},{"text":[{"text":"M.    ","style":"bullet"},{"text":"Negotiated.  ","bold":true,"italics":true},"The Parties have independently, separately, and freely negotiated each provision of this Contract as if all Parties drafted this Contract. The Parties, therefore, waive any statutory or common-law presumption that would serve to have this document construed in favor of, or against, either Party."],"style":"para"},{"text":[{"text":"N.    ","style":"bullet"},{"text":"Headings.  ","bold":true,"italics":true},"The headings of the Articles herein are inserted for convenience only and are not intended to affect the meaning or interpretation of this Agreement."],"margin":[0,0,0,20]},{"text":"BY OUR SIGNATURES WE AGREE TO THE ABOVE TERMS.","bold":true,"margin":[0,0,0,20]},{"text":[{"text":"Contractor:\\t\\t\\t","bold":true},{"text":"{{{userName}}}"},"\\n\\n\\n"]},{"text":[{"text":"DBA:\\t\\t\\t\\t\\t\\t","bold":true},{"text":"{{{companyName}}}"},"\\n\\n\\n"]},{"text":[{"text":"Date:\\t\\t\\t\\t\\t\\t","bold":true},{"text":"{{{date}}}"},"\\n\\n\\n"]},{"text":"Signature:","bold":true},{"canvas":[{"type":"line","x1":75,"y1":0,"x2":210,"y2":0,"lineWidth":1}]},{"image":"{{{signature}}}","fit":[90,250],"margin":[85,-20,0,0]},{"text":["Elite Logistics, Inc.\\n\\n"],"bold":true,"margin":[0,100,0,0]},{"text":[{"text":"Date:\\t\\t\\t\\t\\t\\t","bold":true},{"text":"{{{date}}}"},"\\n\\n\\n"]},{"text":"Signature:","bold":true},{"canvas":[{"type":"line","x1":75,"y1":0,"x2":210,"y2":0,"lineWidth":1}]},{"image":"{{{brentSig}}}","fit":[90,250],"margin":[85,-20,0,0]},{"text":"By: Brent LaFave, President","margin":[75,3,0,0],"pageBreak":"after"},{"text":"Exhibit A\\nPayment Schedule","alignment":"center","bold":true,"fontSize":12,"margin":[0,0,0,20]},{"ol":[{"text":"Contractor shall be compensated at a rate commensurate with the vehicle type used to complete each Assignment, as set out in the Compensation Rate Per Vehicle table below. Notwithstanding the aforesaid, at no time shall Contractor be paid for days or partial days that Contractor spends fulfilling an Assignment that are in excess of a reasonable time necessary to fulfill the Assignment as determined by Elite in its sole discretion. In the event that Contractor is unable or unwilling to complete an Assignment, the compensation shall be adjusted by Elite, taking into consideration the amount of the Assignment completed by Contractor and the damages caused to Elite as a result of the intentional or negligent acts of Contractor.","margin":[0,0,0,8]},{"text":"Contractor shall be compensated for special deliveries (generally deliveries that will take less than 4 hours) and fuel at rates established between Elite and Contractor prior to commencing the delivery.","margin":[0,0,0,8]},{"text":"Elite shall partially reimburse Contractor for fuel used by Contractor in fulfilling an Assignment at a rate determined by a sliding scale, as illustrated by the example fuel reimbursement table below. The rate may vary from Assignment to Assignment based on the agreement between Elite and its customer. The reimbursement is based on a fuel price of $3.00/gallon (see the example fuel reimbursement table below) for regular unleaded gas, an estimated average miles per gallon for delivery vehicles used by contractors of Elite, and an average number of miles per Assignment of Elite contractors. The reimbursement may, but need not, be adjusted up or down by Elite, in its sole discretion, with the price of regular unleaded gas established by the most recent “Fuel Gauge Report” of the American Automobile Association and further based upon fuel charges by Elite to Client. Current reimbursement values can be found in the Fuel tab of the Elite Logistics Driver application.","margin":[0,0,0,8]}]},{"text":"Compensation Rate Per Vehicle:","fontSize":12,"bold":true,"margin":[0,20,0,8]},{"style":"tableExample","table":{"alignment":"left","headerRows":1,"body":[[{"text":"Vehicle","style":"tableHeader"},{"text":"Compensation","style":"tableHeader"}],{{{invite_vehicles}}}]},"layout":"headerLineOnly"},{"text":[{"text":"Compensation Notes:\\t","bold":true},{"text":"{{{invite_payNotes}}}"},"\\n\\n\\n"]},{"text":"Fuel Reimbursement Table (Sample):","fontSize":12,"bold":true,"margin":[0,0,0,8]},{"style":"tableExample","table":{"headerRows":1,"body":[[{"text":"Fuel Price Range","style":"tableHeader"},{"text":"Per Completed Assignment","style":"tableHeader"}],["$3.01 - $3.10","$6.36"],["$3.11 - $3.20","$7.45"],["$3.21 - $3.30","$8.67"],["$3.31 - $3.40","$9.89"],["$3.41 - $3.50","$11.11"],["$3.51 - $3.60","$12.33"],["$3.61 - $3.70","$13.55"],["$3.71 - $3.80","$14.77"],["$3.81 - $3.90","$15.99"],["$3.91 - $4.00","$17.21"]]},"layout":"headerLineOnly"}],"defaultStyle":{"fontSize":9.5,"bold":false,"columnGap":125},"styles":{"listitem":{"italics":true,"margin":[0,0,0,9]},"label":{"bold":true},"link":{"color":"#333","fontSize":8},"para":{"margin":[0,0,0,8]},"section":{"bold":true,"margin":[0,2,0,4]},"dark":{"bold":true},"bullet":{"margin":[0,0,10,0]},"header":{"fontSize":18,"bold":true,"margin":[0,0,0,10]},"tableExample":{"margin":[0,5,0,15],"alignment":"center"},"tableHeader":{"bold":true,"fontSize":10,"color":"black"}}}`

        //
        //  A compilation note:  the "{{{invite_vehicles}}}" tag must be surrounded by double quotes in order to
        //  load it as a json string in the JSON viewer (where is can be formatted and compressed.)  After it
        //  is compressed and added to the this.json variable above, remove the double quotes, or the vehicles
        //  list will not display correctly, and json.parse will fail with an "invalid character at" error.
        //
        /*
        this.formatted = `
{
  "pageSize": "LETTER",
  "pageMargins": [
    72,
    45,
    72,
    45
  ],
  "content": [
    {
      "alignment": "left",
      "bold": true,
      "color": "red",
      "text": "{{{instructions}}}",
      "margin": [
        0,
        -15,
        0,
        0
      ]
    },
    {
      "image": "{{{logo}}}",
      "width": 120,
      "alignment": "center",
      "margin": [
        0,
        0,
        0,
        14
      ]
    },
    {
      "text": "Independent Contractor Master Agreement",
      "alignment": "center",
      "bold": true,
      "fontSize": 12,
      "margin": [
        0,
        0,
        0,
        14
      ]
    },
    {
      "text": "Between",
      "alignment": "center",
      "bold": true,
      "fontSize": 10,
      "margin": [
        0,
        0,
        0,
        14
      ]
    },
    {
      "columns": [
        {
          "text": [
            "Elite Logistics, Inc\\n",
            "Attn: Brent LaFave\\n",
            "730 S Jason St, Unit 28\\n",
            "Denver, CO  80223\\n",
            "Telephone: 303.994.9633"
          ]
        },
        {
          "text": [
            "Contractor:  {{{userName}}}\\n\\n",
            "DBA:  {{{companyName}}}\\n\\n",
            "Telephone:  {{{phone}}}"
          ],
          "alignment": "right"
        }
      ],
      "margin": [
        0,
        0,
        0,
        16
      ]
    },
    {
      "text": [
        {
          "text": "THIS AGREEMENT (",
          "bold": true
        },
        {
          "text": "¨Agreement¨",
          "bold": true
        },
        ") is between Elite Logistics, Inc. (",
        {
          "text": "¨Elite¨",
          "bold": true
        },
        ") and the above named party (",
        {
          "text": "¨Contractor¨",
          "bold": true
        },
        ") [Individually a “Party” and collectively the “Parties”] effective this {{{invite_dayOrdinal}}} day of {{{invite_month}}}, {{{invite_year}}} (the ",
        {
          "text": "¨Effective Date¨",
          "bold": true
        },
        ")."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "WHEREAS",
          "bold": true
        },
        ", Elite provides logistic support to businesses (",
        {
          "text": "“Client[s]”",
          "bold": true
        },
        {
          "text": ") through independent contractors who use their own rolling equipment, supplies, materials, tools and who provide their own fuel, maintenance, and insurance related to the aforesaid; and\\n\\n"
        },
        {
          "text": "WHEREAS",
          "bold": true
        },
        ", Contractor is a business separate and apart from Elite with no overlapping ownership or control; and is customarily engaged in a business related to the service to be performed under this Agreement; and,\\n\\n",
        {
          "text": "WHEREAS",
          "bold": true
        },
        ", Contractor provides workers compensation insurance and unemployment insurance for its employees.\\n\\n",
        {
          "text": "NOW THEREFORE",
          "bold": true
        },
        ", in consideration of the covenants and restrictions herein, the Parties agree:\\n"
      ],
      "style": "para"
    },
    {
      "text": "Section I:  Assignments\\n",
      "style": "section"
    },
    {
      "text": "Elite may present opportunities to Contractor to provide delivery services for Clients (an ¨Assignment¨) setting forth the Client's requirements and needs including the dates and times needed and delivery destination(s) where known.  Contractor shall have the option to accept or reject the Assignment with Clients; however, all Assignments shall be subject to approval of Contractor by the Client.  An assignment will be delivery, or other service, that takes one day or less to complete unless stated otherwise.  An Assignment will not include special deliveries or similar services (generally services that will take four hours or less to complete).",
      "style": "para"
    },
    {
      "text": "Section II:  Subcontract\\n",
      "style": "section"
    },
    {
      "text": "Contractor may fulfill any Assignment by use of its employees or may subcontract an Assignment to a third party.",
      "style": "para"
    },
    {
      "text": "Section III:  Term\\n",
      "style": "section"
    },
    {
      "text": "The term of this Agreement shall commence on the Effective Date and shall be applicable to all Assignments.  Notwithstanding the aforesaid, Elite does not guaranty Contractor any Assignment or reassignment of Contractor to a Client after any Assignment.",
      "style": "para"
    },
    {
      "text": "Section IV:  Disclaimers\\n",
      "style": "section"
    },
    {
      "text": "CONTRACTOR IS NOT ENTITLED TO UNEMPLOYMENT COMPENSATION INSURANCE BENEFITS UNLESS UNEMPLOYMENT COMPENSATION INSURANCE COVERAGE IS PROVIDED BY CONTRACTOR OR SOME OTHER ENTITY;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "CONTRACTOR IS OBLIGATED TO PAY FEDERAL AND STATE INCOME TAX ON ANY MONEYS PAID PURSUANT TO THE CONTRACT RELATIONSHIP;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "CONTRACTOR IS NOT REQUIRED TO ACCEPT AN ASSIGNMENT;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "CONTRACTOR IS NOT REQUIRED TO WORK EXCLUSIVELY FOR ELITE, EXCEPT THAT CONTRACTOR MAY CHOOSE TO WORK EXCLUSIVELY FOR A FINITE PERIOD OF TIME SPECIFIED IN THIS AGREEMENT OR IN AN ASSIGNMENT;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "ELITE DOES NOT ESTABLISH A QUALITY STANDARD FOR CONTRACTOR; EXCEPT THAT ELITE MAY PROVIDE PLANS AND SPECIFICATIONS FOR AN ASSIGNMENT BUT ELITE CANNOT OVERSEE THE ACTUAL ASSIGNMENT OR INSTRUCT CONTRACTOR AS TO HOW THE ASSIGNMENT WILL BE PERFORMED;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "ELITE DOES NOT PAY A SALARY OR HOURLY RATE BUT RATHER A FIXED OR CONTRACT RATE FOR AN ASSIGNMENT;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "ELITE CANNOT TERMINATE AN ASSIGNMENT DURING THE ASSIGNMENT UNLESS CONTRACTOR VIOLATES THE TERMS OF THE ASSIGNMENT OR THIS AGREEMENT OR FAILS TO PRODUCE A RESULT THAT MEETS THE SPECIFICATIONS OF THE ASSIGNMENT;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "ELITE DOES NOT PROVIDE ANYTHING MORE THAN MINIMAL TRAINING FOR CONTRACTOR;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "ELITE DOES NOT PROVIDE TOOLS OR BENEFITS TO CONTRACTOR; EXCEPT THAT MATERIALS AND EQUIPMENT MAY BE SUPPLIED;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "ELITE DOES NOT DICTATE THE TIME OF PERFORMANCE OF AN ASSIGNMENT; EXCEPT THAT A COMPLETION SCHEDULE AND A RANGE OF MUTUALLY AGREEABLE WORK HOURS MAY BE ESTABLISHED;",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "IF CONTRACTOR IS AN INDIVIDUAL, ELITE DOES NOT PAY CONTRACTOR PERSONALLY BUT RATHER MAKES CHECKS PAYABLE TO THE TRADE OR BUSINESS NAME OF CONTRACTOR.",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "ELITE DOES NOT COMBINE ITS BUSINESS OPERATIONS IN ANY WAY WITH CONTRACTOR'S BUSINESS, BUT INSTEAD MAINTAINS SUCH OPERATIONS AS SEPARATE AND DISTINCT.",
      "style": [
        "para",
        "dark"
      ]
    },
    {
      "text": "Section V:  Subcontractors and Employees of Contractor\\n",
      "style": "section"
    },
    {
      "text": "Contractor may use sub-contractors or employees. Contractor shall be solely responsible for the supervision of its employees and contractors and the payment of compensation, wages, workers compensation insurance, unemployment insurance, taxes, and similar matters related to Contractor’s owners, employees, and contractors. Contractor shall save and hold Elite harmless from any claims or demands arising related to the relationship between Contractor and its employees and contractors including, but not limited to: i) claims by Contractor’s owners, employees, or contractors for damages, injuries, losses, payments, salaries, taxes, benefits, or other matters; and, ii) claims by any third parties, including, but not limited to, Clients, unrelated parties, and governmental agencies, for damages, injuries, or losses of any kind related to an Assignment.\\n\\n",
      "style": "para"
    },
    {
      "text": "Section VI:  Relationship Between Parties\\n",
      "style": "section"
    },
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Independent Contractor.  ",
          "bold": true,
          "italics": true
        },
        "Contractor is engaged in an independent business and customarily has performed or does perform services for businesses other than Elite.  Contractor will perform Assignments as an independent contractor and not as an agent, partner, venturer, or employee of Elite."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Training.  ",
          "bold": true,
          "italics": true
        },
        "Elite shall not provide Contractor with any training or continuing education. The cost of any training or continuing education required to perform the Assignment shall be provided and paid by Contractor."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Authority.  ",
          "bold": true,
          "italics": true
        },
        "Contractor does not have the authority to act for or bind Elite in any respect or to incur any debts or liabilities in the name, or on behalf, of Elite."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Coordination.  ",
          "bold": true,
          "italics": true
        },
        "Elite shall not control, oversee, or supervise Contractor in any way in the fulfillment of an Assignment, or control the manner in which Contractor fulfills the Assignment. However, Elite shall be available for consultation, coordination, assistance, coverage issues, and/or advice."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "No Guaranty of Assignments.  ",
          "bold": true,
          "italics": true
        },
        "Elite does not guarantee Assignments to Contractor. Contractor waives any claim against Elite for dependency upon Assignments and shall release, indemnify, and hold Elite harmless from any claims and liabilities relating to Contractor’s financial stability, which may result in a lack of Assignments."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "F.    ",
          "style": "bullet"
        },
        {
          "text": "Workers Compensation Insurance.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall provide Elite with proof, or a waiver, of workers compensation insurance for all owners, employees, or contractors of Contractor in accordance with all applicable laws, prior to commencing any Assignment and thereafter upon request of Elite. All such insurance shall be paid by Contractor. If Contractor does not maintain workers’ compensation insurance as required by law, Elite may recover from Contractor all costs that it sustains in providing workers’ compensation insurance for Contractor’s employees and contractors."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "G.    ",
          "style": "bullet"
        },
        {
          "text": "Business Cards.  ",
          "bold": true,
          "italics": true
        },
        "Contractor may use business cards setting forth Contractor’s name and contact information. Contractor shall not reflect any business relationship with Elite on any business cards, invoices, statements, or, advertisements except for stating that Elite is one of its customers.\\n\\n"
      ],
      "style": "para"
    },
    {
      "text": "Section VII:  Conduct and Performance\\n",
      "style": "section",
      "xpageBreak": "before"
    },
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Quality.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall use its best efforts to complete all Assignments in accordance with the specifications of Assignment."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Identification.  ",
          "bold": true,
          "italics": true
        },
        "While fulfilling an Assignment, Contractor shall furnish and maintain, at its own cost and expense, identification as required by Client (e.g. an identification badge)."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Workplace.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall provide services to and from Clients’ sites and facilities or such other locations as set forth in an Assignment. Any preparatory work required of Contractor to perform an Assignment shall be performed at the workplace of Contractor, and not of Elite, at Contractor’s sole cost and expense."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Equipment.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall provide services to and from Clients’ sites and facilities or such other locations as set forth in an Assignment. Any preparatory work required of Contractor to perform an Assignment shall be performed at the workplace of Contractor, and not of Elite, at Contractor’s sole cost and expense."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "Vehicle.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall provide a vehicle sufficient to perform an Assignment and in relation to such vehicle, Contractor shall:"
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "i)  ",
          "style": "bullet"
        },
        {
          "text": "Vehicle Size",
          "bold": true,
          "decoration": "underline"
        },
        ".  Not use a vehicle for an Assignment with a Gross Vehicle weight in excess of 10,000 pounds."
      ],
      "margin": [
        20,
        0,
        0,
        6
      ]
    },
    {
      "text": [
        {
          "text": "ii)  ",
          "style": "bullet"
        },
        {
          "text": "Expenses",
          "bold": true,
          "decoration": "underline"
        },
        ".  Pay for all costs and expenses associated with such vehicle, including, but not limited to: a) the purchase of the vehicle in Contractor’s business name; b) registration fees; c) license fees; d) inspection fees; d) fines; f) maintenance and repairs; g) personal property taxes; g) sales and use taxes; and h) fuel, oil, fluids, tires, and other replacement parts."
      ],
      "margin": [
        20,
        0,
        0,
        6
      ]
    },
    {
      "text": [
        {
          "text": "iii)  ",
          "style": "bullet"
        },
        {
          "text": "Insurance",
          "bold": true,
          "decoration": "underline"
        },
        ".  Contractor shall provide Elite proof of, and shall maintain at Contractor’s sole cost and expense, insurance in accordance with the following:"
      ],
      "margin": [
        20,
        0,
        0,
        6
      ]
    },
    {
      "text": [
        {
          "text": "a)  ",
          "style": "bullet"
        },
        "Vehicle Insurance: For each vehicle used by Contractor pursuant to an Assignment, Contractor shall maintain insurance coverage with $100,000/$300,000/$500,000 of coverage."
      ],
      "margin": [
        40,
        0,
        0,
        6
      ]
    },
    {
      "text": [
        {
          "text": "b)  ",
          "style": "bullet"
        },
        "Liability Insurance: Contractor shall maintain general liability insurance with a single combined liability limit of not less than one million dollars ($1,000,000.00) insuring against all liability of Contractor and its authorized representatives in connection with an Assignment"
      ],
      "margin": [
        40,
        0,
        0,
        6
      ]
    },
    {
      "text": [
        {
          "text": "c)  ",
          "style": "bullet"
        },
        "Additional Insureds: The above insurance policies shall name Elite as an additional insured and shall provide that the policies may not be changed, non-renewed, terminated, or canceled unless the insurance carrier provides at least thirty (30) days prior written notice of the aforesaid to Elite."
      ],
      "margin": [
        40,
        0,
        0,
        6
      ]
    },
    {
      "text": [
        {
          "text": "F.    ",
          "style": "bullet"
        },
        {
          "text": "Laws.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall comply with all federal, state, municipal, county, or other governmental or quasigovernmental requirements, laws, ordinances, regulations, and rules in the performance of an Assignment."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "G.    ",
          "style": "bullet"
        },
        {
          "text": "Representations.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall commit no deceptive, misleading, or unethical acts in fulfilling an Assignment and shall make no representations, warranties, or guarantees on behalf of Elite."
      ],
      "style": "para"
    },
    {
      "text": "Section VIII:  Payment\\n",
      "style": "section"
    },
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Profits/Losses.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall be entitled to all profits it earns and losses it incurs related to an Assignment."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Invoices.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall periodically invoice Elite for Assignments and, at the request of Elite, shall provide backup documentation for the matters claimed in invoices."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Payments.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall be paid for an Assignment pursuant to the Schedule set forth in Exhibit A as may be modified from time-to-time regardless of the number of hours expended by Contractor. Payment shall be made within 15 business days of receipt by Elite of a complying invoice and Contractor providing any backup documentation requested by Elite."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Trade or Business Name.  ",
          "bold": true,
          "italics": true
        },
        "All payments shall be payable to Contractor’s trade or business name."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "Taxes.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall withhold, contribute, and pay all applicable FICA, federal, state, and local income taxes or assessments for or on behalf of its employees. Elite shall provide Contractor a 1099 tax form after each calendar year in accordance with applicable laws."
      ],
      "style": "para"
    },
    {
      "text": "Section IX:  Indemnification\\n",
      "style": "section",
      "xpageBreak": "before"
    },
    "Contractor shall save and hold Elite, its owners, affiliates, agents, directors, officers, contractors, and employees harmless from any claims, liabilities, costs, or damages incurred as a result of:\\n\\n",
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Taxes.  ",
          "bold": true,
          "italics": true
        },
        "Taxes due for any payment made by Elite to Contractor."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Employees and Contractors.  ",
          "bold": true,
          "italics": true
        },
        "Payments due for services, including taxes due thereon, made to Contractor’s owners, employees, and contractors."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Debts.  ",
          "bold": true,
          "italics": true
        },
        "Any debts, taxes, or liabilities of Contractor."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Acts.  ",
          "bold": true,
          "italics": true
        },
        "Tortuous or contractual acts of Contractor whether or not related to the Assignment."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "Consequential Liability.  ",
          "bold": true,
          "italics": true
        },
        "Liabilities and damages caused to third parties by Contractor."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "F.    ",
          "style": "bullet"
        },
        {
          "text": "Workers Compensation.  ",
          "bold": true,
          "italics": true
        },
        "Worker’s compensation insurance premiums paid by Elite for Contractors employees or contractors."
      ],
      "style": "para"
    },
    {
      "text": "In the event of any claim set forth above against Elite, Contractor shall reimburse Elite for all costs of defense (including but not limited to attorney’s fees, costs, and expenses whether or not suit is actually filed) within 30 days of Elite forwarding an invoice to Contractor for such fees, costs, expenses or damages.",
      "margin": [
        0,
        0,
        0,
        10
      ]
    },
    {
      "text": "Section X:  Termination\\n",
      "style": "section"
    },
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Without Cause.  ",
          "bold": true,
          "italics": true
        },
        "Either Party may terminate this Agreement at any time without notice and without cause in which case Contractor shall not thereafter by offered Assignments. Notwithstanding the aforesaid, this Agreement shall not be terminated during an Assignment unless Contractor violates the terms of an Assignment or fails to meet the specifications of an Assignment."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Payment Upon Termination.  ",
          "bold": true,
          "italics": true
        },
        "Each Party will pay all amounts due to the other Party upon the termination of this Agreement and shall pay any future amounts due to the other Party as they become due. Elite may apply any setoffs it may have against Contractor towards any payment due to Contractor."
      ],
      "style": "para"
    },
    {
      "text": "Section XI:  Confidential Information\\n",
      "style": "section"
    },
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Confidential Information.  ",
          "bold": true,
          "italics": true
        },
        "“Confidential Information” shall mean any business information, including Client information obtained in connection with this Agreement, in a tangible form which is marked as confidential or proprietary, otherwise learned, or which is known, or should be known, to be confidential."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "No Confidential Information to Elite.  ",
          "bold": true,
          "italics": true
        },
        "Elite does not wish to receive Confidential Information from Contractor."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Terms of Non-Disclosure.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall not disclose, use, or copy Confidential Information of Elite during the term of this Agreement (except in furtherance of an Assignment) and for a period of two (2) years thereafter other than in the fulfillment of an Assignment unless specifically authorized to do so in writing by Elite which authorization may be withheld by Elite for any reason or no reason. Contractor shall exercise of at least the same degree of care used to protect its own information of like importance but not less than a reasonable degree of care."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Client.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall be subject to the Indiana Uniform Trade Secrets Act in all of its dealings with Clients."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "On Site Information.  ",
          "bold": true,
          "italics": true
        },
        "The nature of an Assignment may require Contractor to be present at the site of Elite or a Client where Contractor may hear or learn of Confidential Information and Contractor may be required to access information on computers of Elite all of which shall be deemed Confidential Information subject to the restrictions set forth herein."
      ],
      "style": "para"
    },
    {
      "text": "Section XII:  Non-Solicitation of Elite Employees and Contractors\\n",
      "style": "section"
    },
    "Contractor shall not, on its own behalf or on behalf of any third party recruit, solicit, or hire employees or other independent contractors of Elite employed or under contract with Elite during the period of this Agreement or for a period of two (2) years after termination of this Agreement. In the event of a violation of the terms herein, damages will be difficult to ascertain but will nevertheless be real and substantial and as a result thereof, Elite shall be entitled to liquidated damages equal to the average monthly salary or contract payments times six (6) made by Elite to the employee or independent contractor later hired by, or contracting with, Contractor or a third party as a result of the acts of Contractor. Said liquidated damages are fair and reasonable under these circumstances. In addition, such solicitation or hiring will cause immediate and irreparable injury to Elite and as a result thereof, Elite shall be entitled to injunctive relief without bond. For purposes of this Section, the term “Solicit” means any direct or indirect communication of any kind whatsoever, regardless of by whom initiated, inviting, advising, encouraging, or requesting any person or entity, in any manner, to take or refrain from taking any action with Elite as related to their employment by, or contract with, Elite.\\n\\n",
    {
      "text": "Section XIII:  Non-Circumvention and Non-Solicitation of Clients\\n",
      "style": "section"
    },
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Prohibitions.  ",
          "bold": true,
          "italics": true
        },
        "Due to the amount and sensitivity of Confidential Information that will be provided to Contractor, or to which it may have access including, but not limited to, marketing plans, Client billing history, or Elite business operations, and other financial data of Elite. Contractor shall not, on its own behalf or on behalf of any third party, solicit business from any Client using Confidential Information during the term of the Agreement and for a period of one (1) year thereafter."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Solicit.  ",
          "bold": true,
          "italics": true
        },
        "For purposes of this Section, the term “Solicit” means any direct or indirect communication of any kind whatsoever, regardless of by whom initiated, inviting, advising, encouraging, or requesting any person or entity, in any manner, to take or refrain from taking any action which is materially based on or considers Confidential Information."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Damages.  ",
          "bold": true,
          "italics": true
        },
        "In the event of a violation of the Prohibitions stated above, damages will be difficult to determine, but will, nevertheless, be real and substantial and therefore the Parties agree to liquidated damages in an amount equal to the greater of: i) 150% of the average monthly billing by Elite of that Client times 12 during the preceding 12 month period (measured from the date of discovery of the initial violation) or ii) 66 2/3% of the gross amount of the first year’s fees billed to that Client by Contractor on its own behalf or a third party with whom Contractor is or has been associated in the aforesaid solicitation. Such liquidated damages are fair and reasonable under these circumstances."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Injunctive Relief.  ",
          "bold": true,
          "italics": true
        },
        "Notwithstanding the right of Elite to liquidated damages and actual damages, a violation of the prohibitions herein will cause Elite immediate and irreparable injury and as a result thereof, Elite shall be entitled to injunctive relief without bond."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "Notice.  ",
          "bold": true,
          "italics": true
        },
        "Elite shall be entitled to provide notice of this Agreement to any Clients at any time without any liability to Contractor for such disclosure."
      ],
      "style": "para"
    },
    {
      "text": "Section XIV:  Non-Disparagement\\n",
      "style": "section"
    },
    "Contractor shall not disparage Elite, or any of its affiliated companies, employees, officers, agents or contractors or otherwise act in a fashion designed to injure the business of Elite. This provision will not apply to truthful comments in response to a lawful subpoena or other legal process. In the event of a violation of this Section, the Parties agree that damages will difficult to determine, but are nevertheless real and substantial and therefore agree to liquidated damages in the amount equal to $5,000 for each incident of disparagement. Continuous statements made on separate dates, or if on the same date to separate people, shall be considered separate incidents each resulting in liquidated damages in the aforesaid amount. Such liquidated damages are fair and reasonable.\\n\\n",
    {
      "text": "Section XV:  Disputes, Jurisdiction, Mediation\\n",
      "style": "section"
    },
    "In the event of a dispute regarding this Agreement or the relationship or business dealings between the Parties, the following shall apply:\\n\\n",
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Negotiations/Mediation.  ",
          "bold": true,
          "italics": true
        },
        "The Parties shall first attempt in good faith to resolve any dispute through private negotiations. If the dispute is not resolved within 30-days of the first written notice of the dispute, the dispute shall be submitted for mediation in the County of Marion, Indiana, to a mutually agreeable mediator."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Mandatory Arbitration.  ",
          "bold": true,
          "italics": true
        },
        "Any dispute not resolved by mediation as set forth above will be submitted for mandatory arbitration in the County of Marion, Indiana, to a mutually agreeable arbitrator. All costs of arbitration shall be shared equally between the Parties."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Award.  ",
          "bold": true,
          "italics": true
        },
        "The Final Award issued by the arbitrator shall not include comprehensive findings of fact and conclusions of law. Judgment upon the Final Award may be entered in any Indiana Court that has jurisdiction."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Jury Trial.  ",
          "bold": true,
          "italics": true
        },
        "THE PARTIES WAIVE ANY RIGHT TO A TRIAL BY JURY OR BY A JUDGE."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "Attorneys’ Fees.  ",
          "bold": true,
          "italics": true
        },
        "In the event of any arbitration or litigation between the Parties related to this Agreement, the prevailing Party shall be entitled to recover its reasonable attorneys’ fees."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "F.    ",
          "style": "bullet"
        },
        {
          "text": "Damage Limitations.  ",
          "bold": true,
          "italics": true
        },
        "Elite will not be liable to Contractor for any incidental, indirect, special, or consequential damages of any kind including, but not limited to, any loss of business, loss of income, or loss of profit, even if advised of the possibility of such damage or if such damage could have been reasonably foreseen. In the event of any claim by Contractor against Elite, Contractor’s remedies shall be solely limited to the assets of Elite. No officer, director, employee, or agent of Elite shall have any personal liability to Contractor for any claim of Contractor arising out of this Agreement or the relationship between Elite and Contractor. If any such claim exists in law or equity against an officer, director, or other employee or independent contractor of Elite, Contractor waives such claim."
      ],
      "style": "para"
    },
    {
      "text": "Section XVI:  Miscellaneous\\n",
      "style": "section"
    },
    {
      "text": [
        {
          "text": "A.    ",
          "style": "bullet"
        },
        {
          "text": "Execution.  ",
          "bold": true,
          "italics": true
        },
        "This Agreement may be executed in one or more counterparts, each of which shall constitute one and the same instrument. Execution may be by electronic signature wherein delivery shall be deemed completed by e-mail if there is electronic confirmation of receipt and opening of the e-mail by the recipient or by facsimile transmission with confirmation of delivery to the recipient."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "B.    ",
          "style": "bullet"
        },
        {
          "text": "Complete Agreement.  ",
          "bold": true,
          "italics": true
        },
        "This Agreement contains a complete Agreement concerning the contractual relationship between Contractor and  Elite and shall supersede all agreements between the Parties. Contractor acknowledges that Elite has made no further representation regarding the terms of this relationship."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "C.    ",
          "style": "bullet"
        },
        {
          "text": "Assignment.  ",
          "bold": true,
          "italics": true
        },
        "Contractor shall not have the right to assign this Agreement."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "D.    ",
          "style": "bullet"
        },
        {
          "text": "Savings Clause and Severability.  ",
          "bold": true,
          "italics": true
        },
        "If in any action before any Court or tribunal empowered to enforce the terms and conditions herein, any portion or section of this Agreement is found to be unenforceable, illegal, or unlawful for any reason, then such term, restriction, remedy, portion, section, or covenant shall be deemed modified to the extent necessary to make it enforceable. In the event that any of the terms and conditions herein are declared invalid, unenforceable, or void for any reason whatsoever, the remaining terms and conditions shall be in full force and effect and binding upon the Parties herein as if the invalid, unenforceable, or void terms were not made a part hereof."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "E.    ",
          "style": "bullet"
        },
        {
          "text": "Waiver.  ",
          "bold": true,
          "italics": true
        },
        "The failure of either Party to exercise any right shall not be construed to be a waiver unless agreed upon in writing. A waiver in any one instance will not constitute an amendment to this Agreement or indicate any continued waivers of such right on any other occasion."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "F.    ",
          "style": "bullet"
        },
        {
          "text": "Survival.  ",
          "bold": true,
          "italics": true
        },
        "The provisions of this Agreement that by their nature continue after termination will survive the expiration, termination, or cancellation of this Agreement including, but not limited to, §§IX-XV."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "G.    ",
          "style": "bullet"
        },
        {
          "text": "Modifications.  ",
          "bold": true,
          "italics": true
        },
        "No waiver or modification of this Agreement or any covenants herein shall be valid unless made in writing and duly executed by both Parties. No evidence of any waiver or modification shall be offered or received into evidence or any proceeding for arbitration or litigation between the Parties unless such waiver or modification is in writing, duly executed by both Parties."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "H.    ",
          "style": "bullet"
        },
        {
          "text": "Attorneys' Fees.  ",
          "bold": true,
          "italics": true
        },
        "In the event any Party violates any of the terms herein, the defaulting Party shall be liable for the reasonable attorney's fees of the non-defaulting Party incurred as a result of enforcing the terms herein whether or not litigation, mediation, or arbitration is commenced."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "I.    ",
          "style": "bullet"
        },
        {
          "text": "Law.  ",
          "bold": true,
          "italics": true
        },
        "This Agreement shall be governed and controlled by the laws of Indiana and the sole jurisdiction and the venue for hearing any matters arising out of, or related to, this Agreement shall be in the County of Marion, Indiana."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "J.    ",
          "style": "bullet"
        },
        {
          "text": "Assignability.  ",
          "bold": true,
          "italics": true
        },
        "This Agreement shall inure to the benefit of, and shall be binding on, Elite and any entity with which Elite may merge or assign its rights and duties under this Agreement."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "K.    ",
          "style": "bullet"
        },
        {
          "text": "Notices.  ",
          "bold": true,
          "italics": true
        },
        "Any notice required herein shall be effective three days after mailing Certified Mail, in the U.S. Mail, postage prepaid or upon actual receipt if hand-delivered or forwarded by overnight carrier. A notice transmitted and delivered by fax or e-mail or other electronic means shall be effective if there is proof of delivery in which case the effective date shall be the date of delivery. Notice shall be made to the addresses set forth above."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "L.    ",
          "style": "bullet"
        },
        {
          "text": "Time is of the Essence.  ",
          "bold": true,
          "italics": true
        },
        "Time is of the essence in the performance of any duty or requirement in this Agreement and a significant and material term of this Agreement."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "M.    ",
          "style": "bullet"
        },
        {
          "text": "Negotiated.  ",
          "bold": true,
          "italics": true
        },
        "The Parties have independently, separately, and freely negotiated each provision of this Contract as if all Parties drafted this Contract. The Parties, therefore, waive any statutory or common-law presumption that would serve to have this document construed in favor of, or against, either Party."
      ],
      "style": "para"
    },
    {
      "text": [
        {
          "text": "N.    ",
          "style": "bullet"
        },
        {
          "text": "Headings.  ",
          "bold": true,
          "italics": true
        },
        "The headings of the Articles herein are inserted for convenience only and are not intended to affect the meaning or interpretation of this Agreement."
      ],
      "margin": [
        0,
        0,
        0,
        20
      ]
    },
    {
      "text": "BY OUR SIGNATURES WE AGREE TO THE ABOVE TERMS.",
      "bold": true,
      "margin": [
        0,
        0,
        0,
        20
      ]
    },
    {
      "text": [
        {
          "text": "Contractor:\\t\\t\\t",
          "bold": true
        },
        {
          "text": "{{{userName}}}"
        },
        "\\n\\n\\n"
      ]
    },
    {
      "text": [
        {
          "text": "DBA:\\t\\t\\t\\t\\t\\t",
          "bold": true
        },
        {
          "text": "{{{companyName}}}"
        },
        "\\n\\n\\n"
      ]
    },
    {
      "text": [
        {
          "text": "Date:\\t\\t\\t\\t\\t\\t",
          "bold": true
        },
        {
          "text": "{{{date}}}"
        },
        "\\n\\n\\n"
      ]
    },
    {
      "text": "Signature:",
      "bold": true
    },
    {
      "canvas": [
        {
          "type": "line",
          "x1": 75,
          "y1": 0,
          "x2": 210,
          "y2": 0,
          "lineWidth": 1
        }
      ]
    },
    {
      "image": "{{{signature}}}",
      "fit": [
        90,
        250
      ],
      "margin": [
        85,
        -20,
        0,
        0
      ]
    },
    {
      "text": [
        "Elite Logistics, Inc.\\n\\n"
      ],
      "bold": true,
      "margin": [
        0,
        100,
        0,
        0
      ]
    },
    {
      "text": [
        {
          "text": "Date:\\t\\t\\t\\t\\t\\t",
          "bold": true
        },
        {
          "text": "{{{date}}}"
        },
        "\\n\\n\\n"
      ]
    },
    {
      "text": "Signature:",
      "bold": true
    },
    {
      "canvas": [
        {
          "type": "line",
          "x1": 75,
          "y1": 0,
          "x2": 210,
          "y2": 0,
          "lineWidth": 1
        }
      ]
    },
    {
      "image": "{{{brentSig}}}",
      "fit": [
        90,
        250
      ],
      "margin": [
        85,
        -20,
        0,
        0
      ]
    },
    {
      "text": "By: Brent LaFave, President",
      "margin": [
        75,
        3,
        0,
        0
      ],
      "pageBreak": "after"
    },
    {
      "text": "Exhibit A\\nPayment Schedule",
      "alignment": "center",
      "bold": true,
      "fontSize": 12,
      "margin": [
        0,
        0,
        0,
        20
      ]
    },
    {
      "ol": [
        {
          "text": "Contractor shall be compensated at a rate commensurate with the vehicle type used to complete each Assignment, as set out in the Compensation Rate Per Vehicle table below. Notwithstanding the aforesaid, at no time shall Contractor be paid for days or partial days that Contractor spends fulfilling an Assignment that are in excess of a reasonable time necessary to fulfill the Assignment as determined by Elite in its sole discretion. In the event that Contractor is unable or unwilling to complete an Assignment, the compensation shall be adjusted by Elite, taking into consideration the amount of the Assignment completed by Contractor and the damages caused to Elite as a result of the intentional or negligent acts of Contractor.",
          "margin": [
            0,
            0,
            0,
            8
          ]
        },
        {
          "text": "Contractor shall be compensated for special deliveries (generally deliveries that will take less than 4 hours) and fuel at rates established between Elite and Contractor prior to commencing the delivery.",
          "margin": [
            0,
            0,
            0,
            8
          ]
        },
        {
          "text": "Elite shall partially reimburse Contractor for fuel used by Contractor in fulfilling an Assignment at a rate determined by a sliding scale, as illustrated by the example fuel reimbursement table below. The rate may vary from Assignment to Assignment based on the agreement between Elite and its customer. The reimbursement is based on a fuel price of $3.00/gallon (see the example fuel reimbursement table below) for regular unleaded gas, an estimated average miles per gallon for delivery vehicles used by contractors of Elite, and an average number of miles per Assignment of Elite contractors. The reimbursement may, but need not, be adjusted up or down by Elite, in its sole discretion, with the price of regular unleaded gas established by the most recent “Fuel Gauge Report” of the American Automobile Association and further based upon fuel charges by Elite to Client. Current reimbursement values can be found in the Fuel tab of the Elite Logistics Driver application.",
          "margin": [
            0,
            0,
            0,
            8
          ]
        }
      ]
    },
    {
      "text": "Compensation Rate Per Vehicle:",
      "fontSize": 12,
      "bold": true,
      "margin": [
        0,
        20,
        0,
        8
      ]
    },
    {
      "style": "tableExample",
      "table": {
        "alignment": "left",
        "headerRows": 1,
        "body": [
          [
            {
              "text": "Vehicle",
              "style": "tableHeader"
            },
            {
              "text": "Compensation",
              "style": "tableHeader"
            }
          ],
          "{{{invite_vehicles}}}"
        ]
      },
      "layout": "headerLineOnly"
    },
    {
      "text": [
        {
          "text": "Compensation Notes:\\t",
          "bold": true
        },
        {
          "text": "{{{invite_payNotes}}}"
        },
        "\\n\\n\\n"
      ]
    },
    {
      "text": "Fuel Reimbursement Table (Sample):",
      "fontSize": 12,
      "bold": true,
      "margin": [
        0,
        0,
        0,
        8
      ]
    },
    {
      "style": "tableExample",
      "table": {
        "headerRows": 1,
        "body": [
          [
            {
              "text": "Fuel Price Range",
              "style": "tableHeader"
            },
            {
              "text": "Per Completed Assignment",
              "style": "tableHeader"
            }
          ],
          [
            "$3.01 - $3.10",
            "$6.36"
          ],
          [
            "$3.11 - $3.20",
            "$7.45"
          ],
          [
            "$3.21 - $3.30",
            "$8.67"
          ],
          [
            "$3.31 - $3.40",
            "$9.89"
          ],
          [
            "$3.41 - $3.50",
            "$11.11"
          ],
          [
            "$3.51 - $3.60",
            "$12.33"
          ],
          [
            "$3.61 - $3.70",
            "$13.55"
          ],
          [
            "$3.71 - $3.80",
            "$14.77"
          ],
          [
            "$3.81 - $3.90",
            "$15.99"
          ],
          [
            "$3.91 - $4.00",
            "$17.21"
          ]
        ]
      },
      "layout": "headerLineOnly"
    }
  ],
  "defaultStyle": {
    "fontSize": 9.5,
    "bold": false,
    "columnGap": 125
  },
  "styles": {
    "listitem": {
      "italics": true,
      "margin": [
        0,
        0,
        0,
        9
      ]
    },
    "label": {
      "bold": true
    },
    "link": {
      "color": "#333",
      "fontSize": 8
    },
    "para": {
      "margin": [
        0,
        0,
        0,
        8
      ]
    },
    "section": {
      "bold": true,
      "margin": [
        0,
        2,
        0,
        4
      ]
    },
    "dark": {
      "bold": true
    },
    "bullet": {
      "margin": [
        0,
        0,
        10,
        0
      ]
    },
    "header": {
      "fontSize": 18,
      "bold": true,
      "margin": [
        0,
        0,
        0,
        10
      ]
    },
    "tableExample": {
      "margin": [
        0,
        5,
        0,
        15
      ],
      "alignment": "center"
    },
    "tableHeader": {
      "bold": true,
      "fontSize": 10,
      "color": "black"
    }
  }
}
          `
          */
    }

    getDocStructure(args) {
        let dd = Mustache.render(this.json, args)
        let obj = JSON.parse(dd)

        return obj
    }
}
